<template>
	<el-table-column v-bind="$attrs" v-on="$listeners">
	  <slot></slot>
	</el-table-column>
</template>
<script>
export default {
  name: "aia-table-column",
};
</script>